import { Link } from 'react-router-dom';
import { useHeroSettings } from '@/hooks/useHeroSettings';

export default function HeroSection() {
  const { settings } = useHeroSettings();

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] lg:min-h-[600px] overflow-hidden">
      {/* Full background image with position and zoom from admin */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url(${settings.image})`,
          backgroundSize: settings.bgSize,
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Smooth gradient transition from left (solid) to right (transparent) — desktop only */}
      <div className="absolute inset-0 hidden md:block bg-gradient-to-r from-background-50 via-background-50/95 via-15% to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 flex items-end md:items-center w-full min-h-[420px] md:min-h-[520px] lg:min-h-[600px] px-4 sm:px-8 md:px-16 lg:px-24 py-8 md:py-16 lg:py-20">
        <div className="bg-white/60 backdrop-blur-[2px] rounded-xl p-4 md:bg-transparent md:backdrop-blur-none md:p-0 max-w-xl w-full">
          <span className="text-primary-500 text-[10px] sm:text-xs font-bold tracking-widest uppercase mb-2 md:mb-4 block">
            {settings.tagline}
          </span>
          <h1 className="font-heading font-black text-foreground-950 text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-tight mb-3 md:mb-6">
            {settings.heading}
          </h1>
          <p className="text-foreground-600 text-sm md:text-lg leading-relaxed mb-5 md:mb-8 max-w-md">
            {settings.subheading}
          </p>
          <Link
            to={settings.buttonLink}
            className="group inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-xs sm:text-sm font-bold px-5 py-2.5 md:px-6 md:py-3 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            {settings.buttonText}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}